export default {
    'Activity log': 'Activiteiten',
    'Read more': 'Lees meer',
    'Read less': 'Lees minder',

    activity: {
        type: {
            'App\\Models\\Mail': {
                title: 'Mail \'{subject}\' verstuurd',
                to: 'Aan: {to}',
            }
        },
        subjects: {
            'App\\Models\\Wish': 'wens',
            'App\\Models\\MedicalInformation': 'medische informatie',
            'App\\Models\\Address': 'adres',
            'App\\Models\\Note': 'opmerking',
            'App\\Models\\Mail': 'mail',
            'App\\Models\\User': 'gebruiker',
        },
        events: {
            'created': 'aangemaakt',
            'updated': 'bijgewerkt',
            'deleted': 'verwijderd',
            'restored': 'hersteld',
        },
        by: '{entity} {event} | {entity} {event} door',
        noActivity: 'Geen activiteit gevonden',
    }
};
